import { render } from "./SocialMediaLink.vue?vue&type=template&id=0b4c7ea4"
import script from "./SocialMediaLink.vue?vue&type=script&lang=js"
export * from "./SocialMediaLink.vue?vue&type=script&lang=js"

import "./SocialMediaLink.vue?vue&type=style&index=0&id=0b4c7ea4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__